import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  isAuthenticated: boolean;
  tenantId: string | null;
  accountId: string | null;
  email: string | null;
  displayName: string | null;
  role: 'owner' | 'admin' | 'user' | null;
  locale: string;
  timezone: string;
  accessToken: string | null;
  idToken: string | null;
  refreshToken: string | null;
  tokenExpiresAt: number | null;

  login: (params: {
    tenantId: string;
    accountId: string;
    email: string;
    displayName: string;
    role: 'owner' | 'admin' | 'user';
    locale: string;
    timezone: string;
    accessToken: string;
    refreshToken: string;
  }) => void;
  logout: () => void;
  setLocale: (locale: string) => void;
  setTimezone: (timezone: string) => void;
  setTokens: (accessToken: string, idToken: string, refreshToken: string) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      tenantId: null,
      accountId: null,
      email: null,
      displayName: null,
      role: null,
      locale: 'en',
      timezone: 'UTC',
      accessToken: null,
      idToken: null,
      refreshToken: null,
      tokenExpiresAt: null,

      login: (params) =>
        set({
          isAuthenticated: true,
          ...params,
        }),

      logout: () =>
        set({
          isAuthenticated: false,
          tenantId: null,
          accountId: null,
          email: null,
          displayName: null,
          role: null,
          accessToken: null,
          idToken: null,
          refreshToken: null,
          tokenExpiresAt: null,
        }),

      setLocale: (locale) => set({ locale }),
      setTimezone: (timezone) => set({ timezone }),

      setTokens: (accessToken, idToken, refreshToken) =>
        set({ accessToken, idToken, refreshToken }),
    }),
    {
      name: 'prufe-auth',
      partialize: (state) => ({
        tenantId: state.tenantId,
        accountId: state.accountId,
        locale: state.locale,
        timezone: state.timezone,
        // Don't persist tokens in localStorage in production — use httpOnly cookies
      }),
    },
  ),
);
